import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  Box,
  AppBar,
  Tabs,
  Tab,
  Grid,
  Modal,
  CircularProgress,
} from "@mui/material";
import JobTabRoute from "./jobComponent/jobTabRoute";
import Recce from "./mainPart/Recce";
import ManufacturingTable from "./mainPart/Manufacturing";
import Installation from "./mainPart/Installation";
import Audit from "./mainPart/Audit";
import Map from "../Map";
import ModalToCreatePrintingClusters from "./ModalToCreatePrintingClusters";
import GlobalButton from "../../../shared/utils/GlobalButton";

const JobBatches = () => {
  // Tab labels
  const mainTabLabels = ["Recce", "Supply", "Installation", "Audit"];
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [campaignData, setCampaignData] = React.useState();
  const [openModalToCreateJobBatches, setOpenModalToCreateJobBatches] =
    useState(false);
  const [openModalToCreateJobClusters, setOpenModalToCreateJobClusters] =
    React.useState(false);
  const [
    openModalToCreateClustersForPrinting,
    setOpenModalToCreateClustersForPrinting,
  ] = React.useState(false);
  const [openModalToPublishJobClusters, setOpenModalToPublishJobClusters] =
    React.useState(false);
  const { id } = useParams();
  const [requiredTabLabels, setRequiredTabLabels] = React.useState([]);
  let serverURL = process.env.REACT_APP_URL;

  const [activeMainTab, setActiveMainTab] = React.useState(null); // Main tab (Recce, Manufacturing, etc.)
  // Handle tab change
  const handleMainTabChange = (event, newValue) => {
    setActiveMainTab(event.target.name);
  };

  const handleSwitch = () => {
    navigate(`/adminportal/campaign/dashboard/${id}`);
  };

  // Tab labels
  const labelMapping = {
    Fabrication: "Supply",
    Printing: "Supply",
    Painting: "Supply",
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${serverURL}/campaign/viewCampaign/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      if (response?.data?.success) {
        setCampaignData(response.data.data);
        if (response?.data?.data) {
          const tabLabels = [
            // ...new Set(
            //   response.data.data?.scopeOfWork?.servicesNeeded.map(
            //     (service) => labelMapping[service] || service
            //   )
            // ),
            ...new Set(
              response?.data?.data?.servicesNeeded.map(
                (service) => labelMapping[service] || service,
              ),
            ),
          ];
          setRequiredTabLabels(
            mainTabLabels.filter((ele) => tabLabels.includes(ele)),
          );
          setLoading(false);
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching campaign data:", error);
    }
  };
  React.useEffect(() => {
    setLoading(true);
    fetchData();
  }, []);
  React.useEffect(() => {
    if (requiredTabLabels.length > 0) {
      setActiveMainTab(requiredTabLabels[0]); // Set first available tab as active
    }
  }, [requiredTabLabels]);

  if (loading) {
    return (
      <div className="flex justify-center align-center">
        <CircularProgress className="ml-2" size={20} color="inherit" />
      </div>
    );
  }

  const renderActive = () => {
    switch (activeMainTab) {
      case "Recce":
        return (
          <Recce
            openModalToCreateJobBatches={openModalToCreateJobBatches}
            setOpenModalToCreateJobBatches={setOpenModalToCreateJobBatches}
          />
        );
      case "Supply":
        return (
          <ManufacturingTable
            campaignData={campaignData}
            setOpenModalToCreateJobClusters={setOpenModalToCreateJobClusters}
            openModalToCreateJobClusters={openModalToCreateJobClusters}
            setOpenModalToPublishJobClusters={setOpenModalToPublishJobClusters}
            openModalToPublishJobClusters={openModalToPublishJobClusters}
            setOpenModalToCreateClustersForPrinting={
              setOpenModalToCreateClustersForPrinting
            }
            openModalToCreateClustersForPrinting={
              openModalToCreateClustersForPrinting
            }
            service={activeMainTab}
          />
        );
      case "Installation":
        return (
          <Installation
            setOpenModalToCreateJobBatches={setOpenModalToCreateJobBatches}
            openModalToCreateJobBatches={openModalToCreateJobBatches}
            campaignData={campaignData}
          />
        );
      case "Audit":
        return (
          <Audit
            openModalToCreateJobBatches={openModalToCreateJobBatches}
            setOpenModalToCreateJobBatches={setOpenModalToCreateJobBatches}
          />
        );
      default:
        return null;
    }
  };
  return (
    <Box
      sx={{
        padding: 3,
      }}
    >
      {/* Header */}
      <AppBar
        position="static"
        sx={{
          mb: 1,
          padding: 1,
          boxShadow: "none",
          backgroundColor: "transparent",
          color: "gray",
        }}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
          }}
        >
          {/* Left side: Tribal Art 2024 Campaign */}
          <Grid
            item
            xs={12}
            sm={12}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <p className="text-[10px] md:text-[16px] lg:text-[20px] font-bold text-[var(--heading-color)]">
              {campaignData?.campaignTitle
                ? campaignData.campaignTitle
                    .toLowerCase() // Convert entire string to lowercase
                    .split(" ") // Split into words
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
                    .join(" ") // Join words back together
                : "N/A"}
            </p>
            <div style={{ width: "200px" }}>
              <GlobalButton
                variant="primary"
                size="small"
                onClick={handleSwitch}
                rightIcon={
                  <img
                    src="/assests/images/Campaigndash/arrow-up-right.png"
                    alt="dashboard"
                    className="w-5 h-5 object-contain"
                  />
                }
              >
                {`Switch to Dashboard`}
              </GlobalButton>
            </div>
          </Grid>
        </Grid>
      </AppBar>

      <div
        style={{
          height: "77vh",

          overflow: "hidden",
          backgroundColor: "#ffff",
          borderRadius: "1rem",
          padding: "1rem",
          boxShadow: "0 0 4px rgba(0.5, 0.5, 0.5, 0.5)",
        }}
      >
        <JobTabRoute
          tabLabels={requiredTabLabels}
          activeTab={activeMainTab}
          onTabChange={handleMainTabChange}
        />

        <div>{renderActive()}</div>
      </div>
      {/* {openModalToCreateJobBatches && (
        <ModalToCreateJobBatches
          openModalToCreateJobBatches={openModalToCreateJobBatches}
          setOpenModalToCreateJobBatches={setOpenModalToCreateJobBatches}
          campaignData={campaignData}
        />
      )} */}
      {/* {openModalToCreateJobs && (
        <ModalToCreateJobs
          openModalToCreateJobs={openModalToCreateJobs}
          setOpenModalToCreateJobs={setOpenModalToCreateJobs}
          campaignData={campaignData}
        />
      )} */}
      {openModalToPublishJobClusters && (
        <Modal
          sx={{
            marginLeft: "50px", // Adds margin from the left
            paddingLeft: "50px", // Adds padding to the left
            paddingRight: "50px", // Adds padding to the right
            marginTop: "100px", // Adds margin from the top
          }}
          open={openModalToPublishJobClusters}
        >
          <Map
            campaignData={campaignData}
            setOpenModalToPublishJobClusters={setOpenModalToPublishJobClusters}
          />
        </Modal>
      )}

      {/* {openModalToCreateJobClusters && (
        <ModalToCreateClusters
          openModalToCreateJobClusters={openModalToCreateJobClusters}
          setOpenModalToCreateJobClusters={setOpenModalToCreateJobClusters}
          campaignData={campaignData}
        />
      )} */}
      {openModalToCreateClustersForPrinting && (
        <ModalToCreatePrintingClusters
          openModalToCreateClustersForPrinting={
            openModalToCreateClustersForPrinting
          }
          setOpenModalToCreateClustersForPrinting={
            setOpenModalToCreateClustersForPrinting
          }
          campaignData={campaignData}
        />
      )}
    </Box>
  );
};

export default JobBatches;
